
import React from "react";
import PropTypes from "prop-types";

const Toast = ({ message, successIcon, closeIcon, onClose }) => {
    return (
        <div className="flex fixed top-0 z-40 items-center w-full sm:max-w-[608px] md:max-w-[370px] xl:max-w-[626px] py-3 px-2 mt-2 text-toast-success bg-white rounded-md border border-toast-border" role="alert">
            <div className="inline-flex items-center justify-center flex-shrink-0">
                {successIcon}
            </div>
            <div className="ml-3 text-xs md:text-sm font-normal">{message}</div>
            <button
                type="button"
                className="ml-auto -mx-1.5 -my-1.5 pt-1 rounded-md focus:ring-1 focus:ring-th-bg p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500"
                data-dismiss-target="#toast-success"
                aria-label="Close"
                onClick={onClose}
            >
                {closeIcon}
            </button>
        </div>
    );
};

Toast.propTypes = {
    message: PropTypes.string.isRequired,
    successIcon: PropTypes.node.isRequired,
    closeIcon: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default Toast;

// unresuable
// import React from "react";
// import { GoodToastIcon, CloseToastIcon } from "../../../components/common/IconComponents";

// const Toast = ({ onClose }) => {
//     return (
//         <div
//             className="flex mt-40 items-center w-full max-w-2xl p-3 text-toast-success bg-white rounded-md border border-toast-border"
//             role="alert"
//         >
//             <div className="inline-flex items-center justify-center flex-shrink-0">
//                 <GoodToastIcon />
//             </div>
//             <div className="ml-3 text-xs md:text-sm font-normal">
//                 Your Profile Photo has been successfully updated
//             </div>
//             <button
//                 type="button"
//                 className="ml-auto -mx-1.5 -my-1.5 rounded-md focus:ring-1 focus:ring-th-bg p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500"
//                 data-dismiss-target="#toast-success"
//                 aria-label="Close"
//                 onClick={onClose} // Call the onClose function when the close button is clicked
//             >
//                 <CloseToastIcon />
//             </button>
//         </div>
//     );
// };

// export default Toast;


// import { CloseToastIcon, GoodToastIcon } from '../../../components/common/IconComponents';

// const Toast = ({ message, dismissTarget }) => {
//     return (
//         <div id={dismissTarget} className="flex mt-40 items-center w-full max-w-2xl p-3 text-toast-success bg-white rounded-md border border-toast-border" role="alert">
//             <div className="inline-flex items-center justify-center flex-shrink-0">
//                 <GoodToastIcon />
//             </div>
//             <div className="ml-3 text-xs md:text-sm font-normal">{message}</div>
//             <button type="button" className="ml-auto -mx-1.5 -my-1.5 rounded-md focus:ring-1 focus:ring-th-bg p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500" data-dismiss-target={dismissTarget} aria-label="Close">
//                 <CloseToastIcon />
//             </button>
//         </div>
//     );
// };

// export default Toast;
